import { SET_MENU_DATA, RESET_MENU_DATA } from './actionTypes'

const initialState = []

const Menu = (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_DATA:
      return action.menuData
    case RESET_MENU_DATA:
      return initialState
    default:
      return state
  }
}

export default Menu
